
import { Component, Vue } from "vue-property-decorator";
import { CredentialsList as CL } from "@/graph/servicecloud/credentials";
import graph from "@/graph";
import ebiEditbar from "@/components/editbar/ebiEditbar.vue";
import CredentialEdit from "./CredentialEdit.vue";
import ebiActionsButtonBar from "@/components/actionsButtonBar/ebiActionsButtonBar.vue";
import { EventBus } from "@/events/event-bus";

@Component({
	components: {
		ebiEditbar,
		CredentialEdit,
		ebiActionsButtonBar,
	},
})
export default class CredentialsList extends Vue {

	loadingTable = true;
	credentialsList: CL[] = [];

	editbarTitle = "";
	showEditbar = false;
	showAddDialog = false;
	selectedCredentials = "";
	addCredentialForm = {
		name: "",
	};

    search = '';

	get filteredCredentialsList(): CL[]
	{
		return this.search ? this.credentialsList.filter((element) => {
			const s = this.search.toLowerCase();
			if(element.key.toLowerCase().indexOf(s) >= 0)
			{
				return true;
			}
			return false;
		}) : this.credentialsList;
	}

	async createCredential()
	{
		if(
			this.addCredentialForm.name.length <= 1
		)
		{
			return;
		}

		const result = await graph.servicecloud.credentials.createCredential(this.addCredentialForm.name);
		await this.loadTable();
		
		this.showAddDialog = false;
	}

	handleEdit(index: number, row: CL) {
		console.log(index, row);

		this.editbarTitle = "Edit: " + row.id + " (" + row.key + ")";
		this.selectedCredentials = row.key;
		this.showEditbar = true;
	}

    handleDelete(index: number, row: CL) {
		console.log(index, row);
		this.$notify.error({
          title: 'Error',
          message: 'Not yet implemented'
        });
	}

	async loadTable()
	{
		this.loadingTable = true;
    this.reset();
		this.credentialsList = [];
		const result = await graph.servicecloud.credentials.list();
		this.credentialsList = result;
		this.loadingTable = false;
	}

  reset() {
    this.editbarTitle = "";
    this.showEditbar = false;
    this.showAddDialog = false;
    this.selectedCredentials = "";
    this.addCredentialForm = {
      name: "",
    };
  }

	mounted()
	{
		this.loadingTable = true;
		this.loadTable();

    EventBus.$on('environment-changed', () => {
      this.loadTable();
    });
	}
}
